import './index.less';
const SilverFocusable = require('silver-focusable');

/**
 * SilverScrollList
 * @class
 */
export class SilverScrollList extends SilverFocusable {
  constructor(opt) {
    super(opt);
  }

  /**
   * initView 模板方法
   * @memberOf SilverScrollList.prototype
   * @method initView
   * @param {Object} style 样式参数
   * @param {Object} data 数据参数
   * @return {Node} dom对象
   */
  initView(style, data) {
    let scroll = document.createElement('div');
    scroll.className = 'silver-scroll-list';
    scroll.setAttribute('fe-role', 'Scroll');
    let scrollList = document.createElement('div');
    scrollList.className = 'scroll-list silver-scrollList';
    scroll.appendChild(scrollList);
    this.scroll = scroll;
    this.scrollList = scrollList;
    this.className = '';
    this.listClassName = '';
    return scroll;
  }

  /**
   * 重新渲染
   * @param node
   * @param style
   * @param data
   */
  renderView(node, style, data) {
    let cfg = 'scroll_dir:v';
    if (data.type === 'h') {
      cfg = 'scroll_dir:h';
    }
    if (data.isNoCache) {
      cfg += ',disable_cache_pre:yes';
    }
    cfg += ',scroll_use_raf:yes';
    node.setAttribute('fe-cfg', cfg);
    this.className && this.scroll.classList.remove(this.className);
    this.className = data.className || this.className;
    this.className && this.scroll.classList.add(this.className);
    this.listClassName && this.scrollList.classList.remove(this.listClassName);
    this.listClassName = data.listClassName || this.listClassName;
    this.listClassName && this.scrollList.classList.add(this.listClassName);
  }

  /**
   * 隐藏Scroll对象
   */
  hide() {
    this.scroll.style.display = 'none';
  }

  /**
   * 显示Scroll对象
   */
  show() {
    this.scroll.style.display = 'block';
  }

  /**
   * 返回scrollList对象
   */
  getScrollList() {
    return this.scrollList;
  }


  /**
   * 返回Scroll对象
   */
  getScroll() {
    return this.scroll;
  }


  /**
   * 样式拼装
   */
  makeStyle(obj = {}) {
    let style = {
      '>.silver-scrollList': {}
    };
    let left = parseInt(obj.left || 0);
    if (isNaN(left)) {
      left = 0;
    }
    left = left / 192 + 'rem';

    let top = parseInt(obj.top || 0);
    if (isNaN(top)) {
      top = 0;
    }
    top = top / 192 + 'rem';

    obj.data = obj.data || {};
    if (obj.__position__) {
      style['margin-top'] = top;
      style['margin-left'] = left;
      style.left = 0;
      style.top = 0;
      style.position = 'relative';
    } else {
      style.left = left;
      style.top = top;
      style['margin-top'] = 0;
      style['margin-left'] = 0;
      style.position = 'absolute';
    }


    if (obj.width != undefined) {
      let width = obj.width == '100%' ? '100%' : parseInt(obj.width);
      if (isNaN(width)) {
        width = '100%';
      }
      style.width = width == '100%' ? '100%' : (width / 192 + 'rem');
    }

    if (obj.height != undefined) {
      let height = obj.height == '100%' ? '100%' : parseInt(obj.height);
      if (isNaN(height)) {
        height = '100%';
      }
      style.height = height == '100%' ? '100%' : (height / 192 + 'rem');
    }


    let zIndex = parseInt(obj.zIndex || 0);
    if (isNaN(zIndex)) {
      zIndex = 0;
    }
    style['z-index'] = zIndex;
    if (obj.bgColor) {
      style['background-color'] = obj.bgColor;
    }
    if (obj.bgImg) {
      style['background-image'] = 'url(' + obj.bgImg + ')';
      let i = new Image();
      i.src = obj.bgImg;
    }
    if (obj.bgImgMove) {
      style['>.silver-scrollList']['background-image'] = 'url(' + obj.bgImgMove + ')';
      let i = new Image();
      i.src = obj.bgImgMove;
    }
    if (obj.paddingBottom) {
      style['>.silver-scrollList']['padding-bottom'] = parseInt(obj.paddingBottom) / 192 + 'rem' || 0;
    }

    return style;
  }

  /**
   * getName 获取组件名称
   * @memberOf SilverScrollList.prototype
   * @method getName
   * @return {String}
   */
  getName() {
    return 'SilverScrollList';
  }
}



// WEBPACK FOOTER //
// ./~/silver-scroll-list/lib/index.js